import styled from 'styled-components'

export const ErrorMessageStyles = styled.p`
  text-align: start;
  color: red;
  letter-spacing: 1px;
  margin: 2px 0 2px 9px;
  font-weight: 700;
`
